import styled from "styled-components"
import { DropdownButton, Dropdown } from "react-bootstrap"

export const UserDropdownWrapper = styled.div`
    & > .dropdown {
        float: left;
    }
`
export const UserPreview = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    min-height: 37px;
    float: left;
    padding: 4px 10px;
    margin-bottom: 8px;
    margin-right: 5px;
    background: ${(props) => props.theme.userDropdownBackground};

    i {
        margin-left: 7px;
    }
`
export const UserDropdownButton = styled(DropdownButton)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        border-radius: 0;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        background: none !important;
        padding: 6px 12px;
        font-weight: 600;
        font-family: ${(props) => props.theme.openSans};
        font-size: ${(props) => props.theme.fontSizes.md}px;
        color: ${(props) => props.theme.userDropdownColor};
        opacity: ${(props) => (props.disabled ? 0.4 : 1)};
        pointer-events: ${(props) => (props.disabled ? "none" : "all")};

        &::after {
            display: none;
        }
    }

    & > .dropdown-menu {
        max-height: 400px;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0;
        border-radius: 0;
        border: 1px solid ${(props) => props.theme.userDropdownMenuBackground};
        background: ${(props) => props.theme.userDropdownMenuBackground};
    }
`
export const UserDropdownItem = styled(Dropdown.Item)`
    display: block;
    padding: 2px 12px;
    background: transparent;
    transition: ${(props) => props.theme.defaultTransition};

    &:focus {
        outline: none;
        background: transparent;
    }

    &:hover {
        background: ${(props) => props.theme.userDropdownMenuBackgroundHover};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
